import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";

type Props = {
  onOpen: () => void;
};

export const MenuIconButton: FC<Props> = (props) => {
  const { onOpen } = props;

  return (
    <Box
      as="button"
      aria-label="メニューボタン"
      onClick={onOpen}
      display={{ base: "block", md: "none" }}
      p={2}
      cursor="pointer"
      _hover={{ bg: "gray.100" }}
      borderRadius="md"
    >
      <HamburgerIcon boxSize={4} />
    </Box>
  );
};
